// Normalize a search query to match accented characters.
// "vini" matches "Vinícius", "neymar" matches "Neymar".
export function normalizeAccents(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
}

// Returns true if haystack contains needle after accent normalization.
export function matchesSearch(haystack: string, needle: string): boolean {
  if (!needle) return true
  return normalizeAccents(haystack).includes(normalizeAccents(needle))
}
